/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Pix_Key_TypeInputs */

const en_clients_field_pix_key_type = /** @type {(inputs: Clients_Field_Pix_Key_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PIX Key Type`)
};

const pt_br2_clients_field_pix_key_type = /** @type {(inputs: Clients_Field_Pix_Key_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Chave PIX`)
};

/**
* | output |
* | --- |
* | "PIX Key Type" |
*
* @param {Clients_Field_Pix_Key_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_pix_key_type = /** @type {((inputs?: Clients_Field_Pix_Key_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Pix_Key_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_pix_key_type(inputs)
	return pt_br2_clients_field_pix_key_type(inputs)
});